export default {
  bold: 700,
  regular: 500,
};
